import { mapValues } from 'lodash';
/**
 * Version 39 migrations: adding passenger details instruction text
 */
export default function v39(website) {
  return {
    ...website,
    eventVersion: 39,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'AirRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            passengerDetailInstructionalText: 'EventWidgets_AirRequest_NameInstruction__resx'
          }
        };
      }
      return layoutItem;
    })
  };
}
